import { useTranslation } from "react-i18next";
import en from "./faqdata";
import tr from "./faqdata.tr";
import ar from "./faqdata.ar";
import { useMemo } from "react";

const mergeLocalizedFaqs = (base, localized) => {
  return base.map((category) => {
    const localizedCat = localized.find((c) => c.text === category.text);
    const mergedFaqs = category.faqs.map((faq) => {
      const localizedFaq = localizedCat?.faqs.find((f) => f.id === faq.id);
      return {
        ...faq,
        ...localizedFaq,
      };
    });

    return {
      ...category,
      ...localizedCat,
      faqs: mergedFaqs,
    };
  });
};

export const useFaqData = () => {
  const { i18n } = useTranslation();

  return useMemo(() => {
    switch (i18n.language) {
      case "tr":
        return mergeLocalizedFaqs(en, tr);
      case "ar":
        return mergeLocalizedFaqs(en, ar);
      default:
        return en;
    }
  }, [i18n.language]);
};
